import { render } from "./docker-stats.vue?vue&type=template&id=048f3d3c&scoped=true"
import script from "./docker-stats.vue?vue&type=script&lang=js"
export * from "./docker-stats.vue?vue&type=script&lang=js"

import "./docker-stats.vue?vue&type=style&index=0&id=048f3d3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-048f3d3c"]])

export default __exports__